import { APP_INITIALIZER, Injectable, InjectionToken, NgModule } from "@angular/core";
import { IPublicClientApplication, PublicClientApplication } from '@azure/msal-browser';
import { MsalModule, MsalService, MSAL_INSTANCE } from '@azure/msal-angular';
import { ConfigService } from "./config.service";
import { AgmCoreModule, LazyMapsAPILoaderConfigLiteral, LAZY_MAPS_API_CONFIG } from "@agm/core";

const AUTH_CONFIG_URL_TOKEN = new InjectionToken<string>('AUTH_CONFIG_URL');

export function initializerFactory(env: ConfigService, configUrl: string, maps: LazyMapsAPILoaderConfigLiteral): any {
  const promise = env.init(configUrl).then((value) => {
      maps.apiKey = env.getGoogleSettings().GeocodingAPIKey;
  });
  return () => promise;
}

/* FOR DEBUGGING
export function loggerCallback(logLevel: LogLevel, message: string) {
  console.log(message);
}
*/

export function MSALInstanceFactory(config: ConfigService): IPublicClientApplication {
return new PublicClientApplication({
  auth: {
    clientId: config.getAzureSettings().ClientId,
    authority: config.getAzureSettings().Authority,
    redirectUri: config.getAzureSettings().RedirectUri
  },
  /* system: {
    loggerOptions: {
      loggerCallback,
      logLevel: LogLevel.Info,
      piiLoggingEnabled: false
    }
  } */
});
}

@NgModule({
  providers: [
  ],
  imports: [
    MsalModule,
    AgmCoreModule.forRoot({ apiKey: "initialKey"})
  ]
})
export class RecyparcsConfigModule {

  static forRoot(rootUrl: string) {
    return {
      ngModule: RecyparcsConfigModule,
      providers: [
        ConfigService,
        { provide: AUTH_CONFIG_URL_TOKEN, useValue: rootUrl },
        { 
          provide: APP_INITIALIZER, 
          useFactory: initializerFactory,
          deps: [ConfigService, AUTH_CONFIG_URL_TOKEN, LAZY_MAPS_API_CONFIG], multi: true 
        },
        {
            provide: MSAL_INSTANCE,
            useFactory: MSALInstanceFactory,
            deps: [ConfigService]
        },
        MsalService        
      ]
    }    
  }
}